module.exports = __webpack_public_path__ + "img/portfolio-01.a1a8f5db.jpg";